import { render, staticRenderFns } from "./mailbox-settings-auto-forwarding-email.vue?vue&type=template&id=4752d551&scoped=true&"
import script from "./mailbox-settings-auto-forwarding-email.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-auto-forwarding-email.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-settings-auto-forwarding-email.vue?vue&type=style&index=0&id=4752d551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4752d551",
  null
  
)

export default component.exports